// Legal pages (2026-10-22): visitors who arrive from the website get "Back to RitmoIQ website" instead of the app's
// own back control. ritmoiq.com marks its legal links and its legal redirects with ?from=site, and the legal pages keep
// the parameter on their links to each other. The referrer is a best-effort fallback for browsers that cached the
// earlier redirect (without the parameter); it counts only when the legal page is the document the browser loaded —
// after in-app navigation document.referrer still names the page that opened the app.
export const WEBSITE_URL = 'https://ritmoiq.com/';
const WEBSITE_ORIGINS = ['https://ritmoiq.com', 'https://www.ritmoiq.com'];
const FROM_SITE = 'from=site';

export function cameFromWebsite() {
  try {
    if (new URLSearchParams(window.location.search).get('from') === 'site') return true;
    if (!document.referrer || !WEBSITE_ORIGINS.includes(new URL(document.referrer).origin)) return false;
    const [landing] = performance.getEntriesByType('navigation');
    return !!landing && new URL(landing.name).pathname === window.location.pathname;
  } catch {
    return false;
  }
}

// A link to another legal page that keeps the website visitor's way back.
export const legalHref = (path) => (cameFromWebsite() ? `${path}?${FROM_SITE}` : path);
